import React from 'react';

export class CategoryFilterItem extends React.Component {
	checkForActiveClass() {
		if (this.props.filter.filterIsActive) {
			return "active";
		} else {
			return "";
		}
	}

	handleFilterClick = () => {
		this.props.filterById(this.props.filter.filterId);
	}

	render() {
		const activeFilterClass = this.checkForActiveClass();

		return (
			<li>
				<a className={activeFilterClass} onClick={this.handleFilterClick}>{this.props.filter.filterDisplayName}</a>
			</li>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Discover/CategoryFilterItem.js